export default __webpack_public_path__ + "static/screenshot9-59a79d6fbbaf2ae83a690a8ecac43a34.jpg";